import { Component, Input } from '@angular/core';
import { ComponentWithCopy } from '../../intefaces/interfaces';

@Component({
  selector: 'app-stats-min-3-columns',
  imports: [],
  templateUrl: './stats-min-3-columns.html',
  styleUrl: './stats-min-3-columns.css'
})
export class StatsMin3Columns {
  @Input() content!: ComponentWithCopy

}
